// components/FlavorFormSections/FlavorImageUploadSection.jsx
import React from "react";
import { Box, Typography } from "@mui/material";

const FlavorImageUploadSection = ({
  primaryPreview,
  secondaryPreviews,
  handlePrimaryImageChange,
  handleSecondaryImagesChange,
}) => {
  return (
    <>
      {/* Primary Image Upload */}
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Primary Image
        </Typography>
        <input
          type="file"
          accept="image/*"
          onChange={handlePrimaryImageChange}
        />
        {primaryPreview && (
          <img
            src={primaryPreview}
            alt="Primary Preview"
            style={{ width: 100, marginTop: 10, borderRadius: 8 }}
          />
        )}
      </Box>

      {/* Secondary Images Upload */}
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Secondary Images
        </Typography>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleSecondaryImagesChange}
        />
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
          {secondaryPreviews.map((preview, index) => (
            <img
              key={index}
              src={preview}
              alt={`Secondary ${index}`}
              style={{ width: 80, height: 80, borderRadius: 8 }}
            />
          ))}
        </Box>
      </Box>
    </>
  );
};

export default FlavorImageUploadSection;
